import React from 'react';
import TorusSdk, {UX_MODE} from '@toruslabs/customauth';

const useAuthSDK = () => {
  const [authSdk, setAuthSdk] = React.useState<TorusSdk | undefined>(undefined);

  const initAuth = React.useCallback(async () => {
    const torusSdk = new TorusSdk({
      baseUrl: `${window.location.origin}/serviceworker`,
      // enableLogging: true,
      uxMode: UX_MODE.POPUP,
      network: 'testnet',
    });

    await torusSdk.init({skipSw: false});
    return torusSdk;
  }, []);

  React.useEffect(() => {
    initAuth()
      .then(sdk => setAuthSdk(sdk))
      .catch(err => console.error(err));
  }, [initAuth]);

  return authSdk;
};

export default useAuthSDK;
